export const header = [
    '',
    '.______    __        ______   .__   __.  __  ___ ',
    '|   _     |  |      /  __  \\  |  \\ |  | |  |/  / ',
    "|  |_)  | |  |     |  |  |  | |   \\|  | |  '  /  ",
    '|   ___/  |  |     |  |  |  | |  . `  | |    <   ',
    "|  |      |  `----.|  `--'  | |  |\\   | |  .  \\  ",
    '| _|      |_______| \\______/  |__| \\__| |__|\\__\\ ',
    '',
    'Build with 🍾 by AZTEC <https://www.aztecprotocol.com>',
    '',
    '',
].map((text, i) => ({
    text,
    color: i < 7 ? 'blue' : 'grey',
    bold: i < 7,
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVhZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3dlYi10ZXJtaW5hbC9oZWFkZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxDQUFDLE1BQU0sTUFBTSxHQUFXO0lBQzVCLEVBQUU7SUFDRixtREFBbUQ7SUFDbkQscURBQXFEO0lBQ3JELG9EQUFvRDtJQUNwRCxtREFBbUQ7SUFDbkQscURBQXFEO0lBQ3JELHVEQUF1RDtJQUN2RCxFQUFFO0lBQ0Ysd0RBQXdEO0lBQ3hELEVBQUU7SUFDRixFQUFFO0NBQ0gsQ0FBQyxHQUFHLENBQUMsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ2xCLElBQUk7SUFDSixLQUFLLEVBQUUsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxNQUFNO0lBQzlCLElBQUksRUFBRSxDQUFDLEdBQUcsQ0FBQztDQUNaLENBQUMsQ0FBQyxDQUFDIn0=